export const version = __APP_VERSION__
export const commit = __VCS_COMMITHASH__
export const build = __BUILD_NUMBER__
export const branch = __VCS_BRANCH__
export const buildDate = __BUILD_DATE__
export const dataVersion = __DATA_VERSION__

export const fullVersion = version + (build ? `-${commit}-${build}` : `-dev`)

/*
 * Data version (`dv`) sent to Era for versioned file serving.
 *
 * It is the `snapshot`: a content-derived id of the source data inputs,
 * computed at build time by `tools/data-version` and baked into this bundle
 * (the same id is baked into Era). Empty when there is no snapshot (local/dev),
 * in which case `dv` is omitted and Era uses its non-versioned fast path.
 */
export const triaDataVersion = dataVersion || ''

export const dockerImage = build
  ? branch === 'main'
    ? version
    : fullVersion + `-develop`
  : fullVersion

export const {
  version: eraVersion,
  commit: eraCommit,
  build: eraBuild,
  branch: eraBranch,
} = window.ERA_CONFIG?.era || {}

export const eraFullVersion =
  `${eraVersion}-${eraCommit}` + (eraBuild ? `-${eraBuild}` : '')

export const eraDockerImage = eraBuild
  ? eraBranch === 'main'
    ? eraVersion
    : eraFullVersion + `-develop`
  : eraFullVersion

export const versions = {
  version,
  commit,
  build,
  branch,
  full: fullVersion,
  era: eraFullVersion,
} as const
